import { useState, useEffect, type ReactNode } from "react";
import ManageEvents from "./ManageEvents";
import ManageUsers from "./ManageUsers";
import "../css/Admin.css";
import NotificationPanel from "./NotificationPanel";
import { useAppContext } from "../../Context/AppContext";
import { useLocation, useNavigate } from "react-router-dom";
import CreateParteners from "./CreateParteners";
import MuslimInvestRequests from "./MuslimInvestRequests";
import Investors from "./Investors";
import Reports from "./Reports";
import PaymentErrors from "./PaymentErrors";
import Cancellations from "./Cancellations";
import EarlyStageVerifications from "./EarlyStageVerifications";
import ManageMeetings from "./ManageMeetings";
import ManageWelcomeEmails from "./ManageWelcomeEmails";
import type { AdminNavKey } from "../../constants/adminNav";

const ADMIN_PANELS: Record<AdminNavKey, ReactNode> = {
  events: <ManageEvents />,
  meetings: <ManageMeetings />,
  welcomeEmails: <ManageWelcomeEmails />,
  users: <ManageUsers />,
  earlyStage: <EarlyStageVerifications />,
  notificationPanel: <NotificationPanel />,
  parteners: <CreateParteners />,
  "invest-company": <MuslimInvestRequests />,
  investors: <Investors />,
  reports: <Reports />,
  "payment-errors": <PaymentErrors />,
  cancellations: <Cancellations />,
};

const Admin = () => {
  const location = useLocation();
  const [key, setKey] = useState<AdminNavKey>(
    () =>
      ((location.state as { adminTab?: AdminNavKey } | null)?.adminTab as AdminNavKey) ||
      "events",
  );
  const { user, setViewMode } = useAppContext();
  const navigate = useNavigate();

  useEffect(() => {
    const requestedTab = (location.state as { adminTab?: AdminNavKey } | null)
      ?.adminTab;
    if (requestedTab && requestedTab in ADMIN_PANELS) {
      setKey(requestedTab);
    }
  }, [location.state]);

  useEffect(() => {
    if (user?.user?.isAdmin !== 1) {
      navigate("/");
      return;
    }
    setViewMode("admin");
  }, [user, navigate, setViewMode]);

  return (
    <div className="m-0 pb-4">
      <div className="card shadow-lg border-0 p-3">
        {ADMIN_PANELS[key] ?? ADMIN_PANELS.events}
      </div>
    </div>
  );
};

export default Admin;
